export const CATEGORY_COLORS = {
  Physical: '#ff7373',    // Red-ish
  Technical: '#73abff',   // Blue
  Intellectual: '#ffca6e',// Gold
  Creative: '#d873ff',    // Purple
  Vitality: '#10b981',    // Emerald Green
  Career: '#4f46e5',      // Indigo (Professional)
  Wealth: '#fbbf24',      // Amber (Money)
  Mental: '#2dd4bf',      // Teal (Calm/Peace)
  Social: '#f472b6',      // Pink (Relationships)
  Home: '#a78bfa',        // Lavender (Comfort)
  Discipline: '#475569',  // Slate (Strength/Hardness)
  Adventure: '#fb923c',   // Orange (Energy/Outdoors)
  Character: '#94a3b8',   // Light Slate (Ethics/Foundation)
  Logistic: '#9ca3af',    // Gray (Utility/Admin)
  Focus: '#0ea5e9',       // Sky Blue (Clarity)
  Dance: '#ec4899',       // Deep Pink (Movement/Energy)
  
  Default: '#64748b',
};